/**
 * Gestion réactive de l'état pour le formulaire de connexion.
 *
 * Ce module contient :
 * - form : données du formulaire de connexion (email/téléphone et mot de passe).
 * - searchItems : élément utilisé pour stocker ou filtrer des données liées à la recherche
 *                 (ex : suggestions, résultats).
 * - isLoaderLoginFormActivated : indique si le chargement du formulaire de connexion est actif
 *                               (affichage d’un loader/spinner).
 *
 * Utilise reactive() et ref() de Vue 3 pour une gestion d’état fluide.
 */
import type { ILoginForm } from '@/types/form.types';
import { reactive, ref } from 'vue';

export const form = reactive<ILoginForm>({
  email_or_téléphone: '',
  password: '',
});

export const searchItems = ref(null);

export const isLoaderLoginFormActivated = ref(false);
export const isLoaderLoginFormActivatedOnboarding = ref(false);
